export var LAZY_IMAGE = 'LazyImage';
export var LAZY_IMAGE_PLACEHOLDER = 'LazyImagePlaceholder';
//# sourceMappingURL=lazyImage.js.map